var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D1005D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1444 9.60059C18.8113 9.60059 17.7307 10.6813 17.7307 12.0144V21.1614C17.7307 22.4945 18.8113 23.5751 20.1444 23.5751C21.4775 23.5751 22.5582 22.4945 22.5582 21.1614V12.0144C22.5582 10.6813 21.4775 9.60059 20.1444 9.60059ZM22.3041 28.4038C22.304 27.1419 21.279 26.116 20.018 26.116C18.7569 26.116 17.7307 27.142 17.7307 28.4038C17.7307 29.6634 18.7569 30.6894 20.018 30.6894C21.279 30.6894 22.3041 29.6634 22.3041 28.4038Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.3ed658ac18ab1a24667de5f12d7572f3.svg";
export { ForwardRef as ReactComponent };